"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
export default function TheArtOfConnection() {
  const headlineWords = ["Βρείτε", "το", "ξενοδοχείο", "των", "ονείρων", "σας"];
  const {
    ref: metaRef,
    isVisible: metaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: paragraphRef,
    isVisible: paragraphVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: kanjiRef,
    isVisible: kanjiVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="2869" id="απευθείας-κρατήσεις-στην-ελλάδα" className="relative min-h-screen w-full bg-white overflow-hidden">
      {}
      <div ref={kanjiRef} className={`pointer-events-none absolute -bottom-12 -left-8 md:bottom-0 md:left-4 select-none transition-all duration-[1400ms] ease-out ${kanjiVisible ? "opacity-[0.03] translate-y-0" : "opacity-0 translate-y-8"}`} style={{
      fontSize: "clamp(220px, 32vw, 380px)",
      lineHeight: 1,
      color: "var(--foreground)",
      fontFamily: "var(--font-mono)"
    }} aria-hidden="true">
        01
      </div>

      <div className="relative z-10 mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 pt-20 md:pt-24 pb-24 md:pb-20 min-h-screen flex flex-col">
        {}
        <div ref={metaRef} className={`flex justify-end mb-12 md:mb-16 transition-all duration-1000 ease-out ${metaVisible ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2"}`}>
          <span className="text-[11px] tracking-[0.25em] text-muted-foreground font-mono">
            — Ο Νέος Τρόπος να Κλείνετε τις Διακοπές σας
          </span>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-[1.5fr_1fr] gap-12 lg:gap-16 items-center flex-1">
          {}
          <div className="flex flex-col">
            {}
            <div ref={headlineRef} className="mb-10 md:mb-12">
              <div className="mb-8 flex justify-start">
                <Link to="/">
                  <WvcLogo className="h-16 w-auto" />
                </Link>
              </div>
              <h1 className="font-default font-bold leading-[1.05] tracking-tighter text-foreground" style={{
              fontSize: "clamp(56px, 9vw, 120px)"
            }}>
                <span className="block">
                  {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block mr-[0.25em] overflow-hidden align-bottom">
                      <span className={`inline-block transition-all ease-out`} style={{
                    transform: headlineVisible ? "translateY(0)" : "translateY(100%)",
                    opacity: headlineVisible ? 1 : 0,
                    transitionDuration: "900ms",
                    transitionDelay: `${i * 80}ms`
                  }}>
                        {word}
                      </span>
                    </span>)}
                </span>
              </h1>
            </div>

            {}
            <p ref={paragraphRef} className={`max-w-[480px] text-[17px] md:text-[18px] leading-[1.6] font-default text-muted-foreground/70 mb-10 transition-all duration-1000 ease-out ${paragraphVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "500ms"
          }}>
              Βρείτε τις αποκλειστικές προσφορές σε επιλεγμένα καταλύματα σε όλη την Ελλάδα. Έξυπνες κρατήσεις απευθείας με τα καλύτερα ξενοδοχεία.
            </p>

            {}
            <div ref={ctaRef} className={`flex flex-wrap items-center gap-6 md:gap-8 transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            transitionDelay: "650ms"
          }}>
              <Button asChild size="lg" className="rounded-md px-12 h-16 bg-primary text-primary-foreground hover:brightness-110 text-[16px] font-default font-bold shadow-lg">
                <Link to="https://hoteldeals.vlmtravel.com/#/welcome" newTab>Αναζήτηση Deals</Link>
              </Button>

              <Link to="https://hoteldeals.gr/%cf%80%cf%8e%cf%82-%ce%bb%ce%b5%ce%b9%cf%84%ce%bf%cf%85%cf%81%ce%b3%ce%b5%ce%af/" className="group inline-flex items-center gap-2 text-foreground text-[15px] font-default font-semibold border-b border-primary pb-1 transition-colors"><span data-ast-id="f:/src/pages/Home/sections/TheArtOfConnection.tsx|sig:gm90s5" data-ast-start="5418" data-ast-end="5445">Πώς Λειτουργεί</span><br /><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-arrow-right size-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/TheArtOfConnection.tsx|sig:vdeqk1" data-ast-start="5565" data-ast-end="5658"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></Link>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative w-full transition-all duration-[1200ms] ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "200ms"
        }}>
            <div className="relative overflow-hidden rounded-md shadow-2xl" style={{
            aspectRatio: "3 / 4"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/andros_island_view.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/andros_island_view.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698288/img/andros_island_view.png-wvc-sizes" alt="Scenic view of Andros island architecture and sea" loading="lazy" decoding="async" className="absolute inset-0 h-full w-full object-cover" />
              {}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "linear-gradient(180deg, hsla(220, 20%, 4%, 0.1) 0%, hsla(220, 20%, 4%, 0.4) 100%)"
            }} />
            </div>
          </div>
        </div>

        {}
        <div className="flex justify-center mt-12 md:mt-10">
          <div className="flex flex-col items-center gap-3">
            <span className="text-[10px] tracking-[0.3em] uppercase font-mono text-muted-foreground">
              Scroll
            </span>
            <div className="relative h-12 w-px overflow-hidden bg-border">
              <span className="absolute left-0 top-0 w-px bg-primary" style={{
              height: "50%",
              animation: "pelagoScrollLine 2.2s ease-in-out infinite"
            }} />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes pelagoScrollLine {
          0% { transform: translateY(-100%); }
          50% { transform: translateY(0%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}